import React from "react";
import Header from "../components/header/Header";
import Banner from "../components/main/Banner";
import Main from "../components/main/Main";
import Footer from "../components/footer/Footer";

const Landing = () => {
  return (
    <div>
      <Header />
      <Banner />
      <Main />
      <Footer />
    </div>
  );
};

export default Landing;
